export default {"src":"/_next/static/media/btm.870eca0b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};